import React from "react";
import { Button } from "react-bootstrap";
const CButton = ({ name, action, variant = "success", style = "", type = "button", src }) => {
  return (
    <Button
      type={type}
      variant={variant}
      className={"me-2" + style}
      onClick={action}
    >
      {src && <img src={src} style={{ height: "15px", width: "15px", marginRight: "5px" }} alt="icon" id="btn-img" />}
      {name}
    </Button>
  );
};

export default CButton;
